import { immerable } from "immer";
import User from "./user.ts";
import Organisation from "./organisation.ts";
import ProjectSynchronisation from "./project-synchronisation.ts";
import ProjectLock from "./project-lock.ts";
import Localisation from "./localisation.ts";
import BaamerProjectDto from "../interfaces/dtos/baamer-project-dto.ts";
import FlowMode from "../enums/flow-mode.ts";

class BaamerProject {
    [immerable] = true;

    id: string;

    projectBoomerId: number;

    baamerRevisionId: string;

    baamerRevisionNumber: number;

    boomerRevisionId: string;

    boomerRevisionNumber: number;

    name: string;

    projectOwner: User;

    projectOrganisation: Organisation;

    projectSynchronisation?: ProjectSynchronisation;

    projectLock?: ProjectLock;

    localisation: Localisation;

    createdDate: Date;

    flowMode: FlowMode;

    constructor(dto: BaamerProjectDto) {
        this.id = dto.id;
        this.projectBoomerId = dto.projectBoomerId;
        this.baamerRevisionId = dto.baamerRevisionId;
        this.baamerRevisionNumber = dto.baamerRevisionNumber;
        this.boomerRevisionId = dto.boomerRevisionId;
        this.boomerRevisionNumber = dto.boomerRevisionNumber;
        this.name = dto.name;
        this.projectOwner = new User(dto.projectOwner.userGUID, dto.projectOwner.email);
        this.projectOrganisation = new Organisation(dto.organizationId, dto.organization.name);
        if (dto.projectSynchronization) this.projectSynchronisation = new ProjectSynchronisation(dto.projectSynchronization);
        if (dto.latestProjectLock) this.projectLock = new ProjectLock(dto.latestProjectLock);
        this.localisation = new Localisation(dto.localisation);
        this.createdDate = new Date(dto.createdDate);
        this.flowMode = dto.flowMode;
    }
    
    updateFromDto(dto: BaamerProjectDto) {
        this.baamerRevisionId = dto.baamerRevisionId;
        this.baamerRevisionNumber = dto.baamerRevisionNumber;
        this.boomerRevisionId = dto.boomerRevisionId;
        this.boomerRevisionNumber = dto.boomerRevisionNumber;
    }


    public setProjectLock(projectLock: ProjectLock): void {
        this.projectLock = projectLock;
    }

    public lockProject(): void {
        if (this.projectLock != null)
            this.projectLock.lock();
    }

    public unlockProject(): void {
        if (this.projectLock != null)
            this.projectLock.unlock();
    }
}

export default BaamerProject;